import React from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';


// Distributor view page  component


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};

export default class UpcomingEventsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            noOfParams: [],
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            Title: this.props.siCurrentData.title,
            StartTime: this.props.siCurrentData.start_time,
            Description: this.props.siCurrentData.description,
            CTA : this.props.siCurrentData.cta,
            EndTime: this.props.siCurrentData.end_time,
            errorMessage: [],

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {

        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);

        })
    }



    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event
        });
    };

    formatTime(dateTime) {
        const date = new Date(dateTime);
    
        // Check if the date is "Today"
        const today = new Date();
        const isToday =
          date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear();
    
        // Format the time
        const startTime = new Intl.DateTimeFormat('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        }).format(date);
    
        // Assuming the duration is 1 hour (replace with your logic for end time)
        // const endTime = new Intl.DateTimeFormat('en-US', {
        //   hour: 'numeric',
        //   minute: 'numeric',
        //   hour12: true,
        // }).format(new Date(date.getTime() + 60 * 60 * 1000));
    
        return `${isToday ? 'Today' : date.toLocaleDateString('en-US')}, ${startTime}`;
      }

    render() {
        return (
            <React.Fragment>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>VIEW UPCOMMING EVENTS</h3>
                    <div className="row">
                        <div className="col-6 mx-0 px-0 disableEvent">
                            <InputBox
                                inputText={this.state.Title}
                                error={false}
                                errorText=""
                                placeholder="Upcoming Event Title:"
                                inputBoxName="Title"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true}
                            />
                        </div>
                        <div className="col-6  disableEvent"
                        //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
                        >
                            <InputBox
                                inputText={this.formatTime(this.state.StartTime)}
                                error={false}
                                errorText=""
                                placeholder="Start Time"
                                inputBoxName="StartTime"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>



                        <div className="col-6 mx-0 px-0 disableEvent">
                            <InputBox
                                inputText={this.state.Description}
                                error={false}
                                errorText=""
                                placeholder="Description"
                                inputBoxName="Description"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>

                        <div className="col-6  disableEvent"
                        //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
                        >
                            <InputBox
                                inputText={this.formatTime(this.state.EndTime)}
                                error={false}
                                errorText=""
                                placeholder="End Time"
                                inputBoxName="EndTime"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>

                        <div className="col-6 mx-0 px-0 disableEvent">
                            <InputBox
                                inputText={this.state.CTA}
                                error={false}
                                errorText=""
                                placeholder="CTA"
                                inputBoxName="CTA"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>

                    </div>

                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
